<template>
    <div style="position: relative">
        <div class="menu-content" v-if="disabled">
            <div class="menu-content-text-wrapper">
                <h3>
                    Настройте
                    <router-link :to="addConnectorLink" v-if="checkAccess(project.id, 'admin')"
                        >«Источники»</router-link
                    >
                    <span v-else>«Источники»</span>
                </h3>
            </div>
        </div>

        <div
            class="dashboard-card"
            :class="{
                marketplace: type === 'marketplace',
                'dashboard-card--disabled': disabled,
            }"
            @click="goToPath"
            :id="id"
        >
            <div v-if="formattedBadgeCount" class="dashboard-card__badges">
                <span class="dashboard-card__counter-badge">
                    {{ formattedBadgeCount }}
                </span>
            </div>
            <div
                class="icon-circle"
                :class="{ 'icon-circle--full-bleed': icon.fullBleedImage }"
                :style="{ background: icon.fullBleedImage ? 'transparent' : icon.color }"
            >
                <v-img
                    v-if="icon.image"
                    :src="icon.image"
                    :contain="!icon.fullBleedImage"
                    :width="icon.fullBleedImage ? '100%' : 24"
                    :height="icon.fullBleedImage ? '100%' : 24"
                />
                <v-icon v-else color="white" :size="icon.size || 24"> {{ icon.name }}</v-icon>
            </div>
            <div class="card-text">
                <span class="dashboard-card__title" v-if="!disabled">
                    {{ name }}
                    <span v-if="showNewBadge" class="dashboard-card__new-badge">New</span>
                </span>
                <span class="dashboard-card__description" v-if="!disabled">
                    {{ description }}
                </span>
            </div>
            <div v-if="projectStatus === 'lock'" class="alert-icon" :style="{ backgroundColor: 'red' }">
                <v-icon color="white"> mdi-alert-circle-outline </v-icon>
            </div>
            <button
                v-if="hintLink"
                class="wc-hint"
                type="button"
                @click.stop="gotToHintLink"
            >?</button>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { checkAccess } from '@/utils'
import { isChatSectionPath, trackMultichatOpen } from '@/helpers/gcb2/multichatAnalytics'
import { useProject } from '@root/src/hooks/useProject'
import { useBillingStore } from '@root/src/store/stores/billing'
import { computed } from 'vue'
import { mapState, mapGetters, mapActions } from 'vuex'
////
export default {
    name: 'DashboardCard',
    components: {},
    data: () => ({}),
    setup(props, { emit }) {
        const { project } = useProject()
        const billingStore = computed(()=>useBillingStore())
        const currentTariff = computed(()=> billingStore.value.getCurrentTariffState(project.value.id))
        return {
            currentTariff,
            project,
        }
    },
    props: {
        id: {
            type: String,
            default: null,
        },
        requiredConnectorTypes: {
            type: Array,
            default: () => [],
        },

        name: {
            type: String,
            default: 'Название отчета',
        },
        description: {
            type: String,
            default: '',
        },
        icon: {
            type: Object,
            default: () => {},
        },
        path: {
            type: String,
            default: '/',
        },
        chartData: {
            type: Object,
            default: () => {},
        },
        type: {
            type: String,
            default: 'default',
        },
        projectStatus: {
            type: String,
            default: 'open',
        },
        showNewBadge: {
            type: Boolean,
            default: false,
        },
        hintLink: {
            type: String,
            default: '',
        },
        badgeCount: {
            type: Number,
            default: 0,
        },
        blocked: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['projectById']),
        formattedBadgeCount() {
            if (!this.badgeCount || this.badgeCount <= 0) return ''
            return this.badgeCount >= 99 ? '99+' : String(this.badgeCount)
        },
        isDemo() {
            if (!this.chartData) {
                return false
            } else {
                if (this.chartData.isDemo) {
                    return true
                } else {
                    return false
                }
            }
        },
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        addConnectorLink() {
            return `/project/${this.project.id}/addConnectorStage1`
        },
        disabled() {
            const connectors = this.project.connectors
            if (!connectors) {
                return true
            }
            if (this.requiredConnectorTypes.length === 0) {
                return false
            }
            if (this.project?.settings?.forcedShowWidgets) {
                return false
            }
            return !connectors.some(
                connector =>
                    this.requiredConnectorTypes.includes(connector.connectorType) && !connector.isDraft
            )
        },
    },
    methods: {
        checkAccess,
        goToPath() {
            if (this.disabled) {
                return
            }
            if (this.blocked) {
                this.$emit('blocked-dashboard-click', {
                    id: this.id,
                    name: this.name,
                    path: this.path,
                    blocked: this.blocked,
                })
                return
            }
            if (isChatSectionPath(this.path)) {
                trackMultichatOpen('project_card')
            }
            // Если path начинается с #, это якорь для скролла на текущей странице
            if (this.path.startsWith('#')) {
                const elementId = this.path.substring(1)
                const element = document.getElementById(elementId)
                if (element) {
                    // Скроллим с оффсетом, чтобы заголовок (например, "Интеграции") не прятался под фиксированной шапкой
                    const appBar = document.querySelector('.v-app-bar') || document.querySelector('header')
                    const headerOffset = (appBar && appBar instanceof HTMLElement) ? appBar.offsetHeight : 0
                    const extraOffset = 16
                    const top = element.getBoundingClientRect().top + window.scrollY - headerOffset - extraOffset
                    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
                    // Если это виджет "Настройка схем отправки", переключаемся на первую вкладку (Каналы отправки)
                    if (this.id === 'SendingSchemes') {
                        this.$nextTick(() => {
                            this.$root.$emit('switch-to-channels-tab')
                        })
                    }
                    return
                }
            }
            const currentRoute = this.$router.currentRoute.path
            this.$router.push(`${currentRoute}${this.path}`.replaceAll('//','/'))
        },
        gotToHintLink() {
            const link = this.hintLink
            if (link) {
                window.open(link, '_blank')
            }
        },
        TODO() {
            //TODO:действия в конетексном меню в карточках отчеов
        },
    },
    created() {},
}
</script>
<style lang="sass" scoped>
@import '@/vars.sass'
.dashboard-card
    width: 100%
    box-sizing: border-box
    background: #fff
    border: 1px solid $border-new
    border-radius: 15px
    padding: 17px 18px
    display: flex
    align-items: flex-start
    gap: 13px
    cursor: pointer
    position: relative
    transition: transform .15s, box-shadow .15s, border-color .15s
    box-shadow: 0 1px 2px rgba(26, 26, 46, .03)
    height: 100%
    &:hover
        transform: translateY(-2px)
        box-shadow: 0 10px 24px rgba(26, 26, 46, .08)
        border-color: #D6DCE8
    &.marketplace
        background: radial-gradient(ellipse at left top, #FFFFFF 5%, #BDDFFB)
        border-color: #BDDFFB
    &--disabled
        cursor: default
        &:hover
            transform: none
            box-shadow: 0 1px 2px rgba(26, 26, 46, .03)
            border-color: $border-new
    &__title
        font-family: $font-family-base
        font-size: 14px
        font-weight: 800
        letter-spacing: -.01em
        color: $dark-new
        line-height: 1.2
        display: flex
        align-items: center
        gap: 8px
        flex-wrap: wrap
    &__description
        font-size: 12px
        color: $muted-new
        line-height: 1.45
        margin-top: 5px

.dashboard-card__badges
    position: absolute
    right: 10px
    top: 10px
    z-index: 2
    display: flex
    align-items: center
    gap: 6px

.dashboard-card__new-badge
    font-family: $font-family-base
    font-size: 8.5px
    font-weight: 800
    letter-spacing: .06em
    text-transform: uppercase
    background: $main-new
    color: #fff
    border-radius: 5px
    padding: 2px 6px
    line-height: 1.2
    flex-shrink: 0

.dashboard-card__counter-badge
    min-width: 18px
    height: 18px
    padding: 0 5px
    border-radius: 9px
    background: #E53935
    color: #fff
    font-size: 10px
    font-weight: 700
    line-height: 18px
    text-align: center
    box-shadow: 0 0 0 2px #fff

.alert-icon
    width: 12px
    height: 12px
    min-width: 12px
    min-height: 12px
    border-radius: 50%
    position: absolute
    right: 6px
    top: 6px
    display: flex
    justify-content: center
    align-items: center

.icon-circle
    width: 44px
    height: 44px
    min-width: 44px
    min-height: 44px
    border-radius: 13px
    display: flex
    justify-content: center
    align-items: center
    flex-shrink: 0
    position: relative
    overflow: hidden
    color: #fff
    border: 1px solid rgba(255, 255, 255, .55)
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .42), 0 7px 16px rgba(26, 26, 46, .08)

    &::before
        content: ''
        position: absolute
        inset: 0
        background: radial-gradient(circle at 28% 18%, rgba(255, 255, 255, .35), transparent 34%), linear-gradient(180deg, rgba(255, 255, 255, .16), rgba(255, 255, 255, 0) 48%)
        pointer-events: none

    :deep(.v-icon),
    :deep(.v-image)
        position: relative
        z-index: 1
        filter: drop-shadow(0 1px 1px rgba(26, 26, 46, .18))

    // Готовая квадратная иконка (свой градиент и тень внутри картинки) —
    // глянец/рамку/тень контейнера убираем, иначе они дублируют то, что
    // уже нарисовано в самом файле.
    &--full-bleed
        border: none
        box-shadow: none

        &::before
            display: none

        :deep(.v-icon),
        :deep(.v-image)
            filter: none

.v-list-item
    padding: 0 !important
    min-height: 0px

button:focus
    outline: 0

.menu
    box-shadow: none !important
    opacity: 1 !important

.menu-content
    position: absolute
    z-index: 1
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    padding-left: 74px
    height: 100%
    min-height: 78px
    opacity: 1 !important
    background-color: rgba(255, 255, 255, 0.4)
.menu-content-text-wrapper
    user-select: all
    width: 250px
    opacity: 1 !important
.card-text
    display: flex
    align-items: flex-start
    justify-content: space-between
    flex-direction: column
    flex: 1
    min-width: 0
.wc-hint
    position: absolute
    bottom: 10px
    right: 10px
    width: 14px
    height: 14px
    border-radius: 50%
    background: rgba(26, 32, 64, .06)
    border: none
    cursor: pointer
    display: flex
    align-items: center
    justify-content: center
    font-size: 8px
    color: $muted-new
    padding: 0
    line-height: 1
    font-family: $font-family-base
    font-weight: 600
    flex-shrink: 0
    transition: background-color .15s ease, color .15s ease, transform .1s ease

    &:hover
        background: rgba($text-color-new, .12)
        color: $text-color-new

    &:active
        background: rgba($text-color-new, .16)
        transform: translateY(1px)

    &:focus-visible
        outline: 2px solid rgba($main-new, .35)
        outline-offset: 1px
</style>
